import React from 'react';
import { IconTorgetShipping24 as IconTorgetShipping } from '@fabric-ds/icons/react';
import { Recommendation, ShippingOption } from '../../types';


type ShippingOptionProps = {
  recommendation: Recommendation
  className?: string;
  shippingLabelClass?: string;
};

function getShippingLabel(shippingOption: ShippingOption): string {
  if(shippingOption === undefined || shippingOption === null) {
    return null
  } else {
    return shippingOption.label
  }
}

function ShippingOptionLabel(props: ShippingOptionProps) {
  const { recommendation, className } = props;

  const shippingLabel = getShippingLabel(recommendation.shippingOption)

  const shippingLabelClass = `
    py-4 
    px-8 
    inline-flex 
    rounded-tl-8 
    rounded-br-4 
    text-12 
    text-yellow-800 
    border-bluegray-300 
    border-l
    border-t
    bg-yellow-100`;

  return shippingLabel ? (
    <div className={className}>
      <span className={shippingLabelClass}>
        <IconTorgetShipping className='w-16 h-16 mr-4' />
        {shippingLabel}
      </span>
    </div>
  ) : null;
}

export default ShippingOptionLabel;